import { OutlineButton } from "Components/HomeV2/Buttons";
import campaginBg from "../../Assets/AIOnDemand/campaigns.png";

const list = [
    {
        title: "5-Day Launch:",
        description: "Zero to launch in just five days.",
    },
    {
        title: "Top Selling Turnkey Solution:",
        description: "The blueprint for your success.",
    },
    {
        title: "Instant Brand & Target Market:",
        description: "Tailored to your brand.",
    },
    {
        title: "Lead Flow & Pipeline Management:",
        description: "Keep your sales engine running smoothly.",
    },
    {
        title: "Expert Sales Team:",
        description: "Our experts, your extended team.",
    },
    {
        title: "Customize For Your:",
        description: "Tailored solutions, because one size does not fit all.",
    },
];

const AIOnDemand = () => {
    return (
        <section className="w-full bg-black">
            <div className="max-w-[1300px] md:pt-16 py-7 md:pb-0 px-7 md:px-0 mx-auto lg:grid flex flex-col gap-3 lg:grid-cols-4 ">
                <div className="text-center text-white mx-auto flex justify-center items-center flex-col lg:-mr-24 lg:pt-16 mb-5 md:mb-0">
                    <p className="font-medium text-xl lg:text-[2rem] mb-3">
                        Cut Costs
                    </p>
                    <p className="text-sm md:text-lg">
                        You'll only get what works. We cut through the hype and implement what drives real pipeline growth.</p>
                </div>
                <div className="lg:col-span-2 mb-5 lg:mb-0 space-y-3 flex flex-col">
                    <div className="text-center text-white mx-auto mb-5">
                        <p className="font-medium text-xl lg:text-[2.5rem] mb-3">
                            AI OnDemand
                        </p>
                        <p className="text-[1rem]">Sales + Marketing + Tech. Fast Tracked.</p>
                    </div>
                    <div className="w-fit mx-auto pb-0 md:pb-3">
                        <a href={"https://calendly.com/salesbox-meet/ai-ondemand"} target="_blank" rel="noreferrer">
                            <OutlineButton size="md">
                                Learn more
                            </OutlineButton>
                        </a>
                    </div>
                    <div className="text-center text-white mx-auto">
                        <p className="font-medium text-xl lg:text-[2rem] mb-3 mt-5 md:mt-0">
                            Grow Revenue
                        </p>
                        <p className="text-sm md:text-lg">
                            We'll map your growth bottlenecks and build a no-fluff AI plan<br /> tailored to unlock them —step-by-step.</p>
                    </div>
                    <div className=" h-fit w-full">
                        <img
                            src={campaginBg}
                            className="object-contain h-fit"
                            alt="campaigns"
                        />
                    </div>

                </div>
                <div className="text-center text-white mx-auto flex justify-center items-center flex-col lg:-ml-24 lg:pt-16">
                    <p className="font-medium text-xl lg:text-[2rem] mb-3 mt-5 md:mt-0">
                        Save Time
                    </p>
                    <p className="text-sm md:text-lg">
                        We deploy proven AI tools to automate tasks, streamline outreach, drive revenue and shorten your sales cycle.</p>
                </div>

            </div>
        </section>
    );
};

export default AIOnDemand;
